import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
const BASE_URL = "https://newalemny.3almny.app/api";

// Async thunk for fetching duty student details
export const fetchDutyStudentDetails = createAsyncThunk(
  'dutyStudentDetails/fetchDutyStudentDetails',
  async ({ lessonId, studentId }, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem('token3almny');
      
      if (!token) {
        throw new Error('No token found');
      }

      const response = await axios.get(`${BASE_URL}/duties/student_lesson_answer/${lessonId}?student_id=${studentId}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      const data = response.data;

      if (data.status === 'success') {
        return data.result;
      } else {
        return rejectWithValue(data.message || 'حدث خطأ في تحميل تفاصيل الواجب');
      }
    } catch (error) {
      console.error('Error fetching duty student details:', error);
      return rejectWithValue(error.message || 'حدث خطأ في تحميل تفاصيل الواجب');
    }
  }
);

const initialState = {
  dutyDetails: null,
  loading: false,
  error: null
};

const dutyStudentDetailsSlice = createSlice({
  name: 'dutyStudentDetails',
  initialState,
  reducers: {
    clearDutyStudentDetails: (state) => {
      state.dutyDetails = null;
      state.error = null;
    },
    clearDutyStudentDetailsError: (state) => {
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDutyStudentDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDutyStudentDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.dutyDetails = action.payload;
        state.error = null;
      })
      .addCase(fetchDutyStudentDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { clearDutyStudentDetails, clearDutyStudentDetailsError } = dutyStudentDetailsSlice.actions;
export default dutyStudentDetailsSlice.reducer;
